import React from 'react';

import './GameBoard.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { CountdownTimer } from '../../CountdownTimer';
import GameInterface from './GameInterface';
import { playSound, stopSound } from '../../../utils/audio-helper';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

export default function GameBoard(props) {

	const {
			question,
			answer,
			placement,
			hasAnsweredCallback,
			timerEndCallback,
			answerSet,
			setQOptDone,
			isQOptAllDone,
			checkWinCondition,
			userGameStatus,
			qOpt,
			avatar,
			sounds
	 	} = props,
		[pauseTimer, setPauseTimer] = useState(false);

	// console.log('GameBoard props', props, fields);

	useEffect(()=>{
		stopSound(sounds, 'rules');
   	// playSound(sounds, 'game', {loop: true, fadeInDelay: 9000, volume: 0.3});
	},[]);

	return (
		<div className='split-second-game-board'>
			<header>
				<div className='clock-container'>
					<CountdownCircleTimer
						isPlaying
						duration={60}
						colors={'#CFAB53'}
						onComplete={()=>{
							timerEndCallback();
						}}
						size={70}
						strokeWidth={7}
						className={'clock'}
						trailColor={'#ffffff00'}
					>
						{({ remainingTime }) => remainingTime}
					</CountdownCircleTimer>
				</div>
				<div className='logo-container'>
					<div className="logo" />
					{/* <div className="tunein">Weeknights 7p</div> */}
				</div>
			</header>
			<GameInterface
				question={question}
				answer={answer}
				qOpt={qOpt}
				setQOptDone={setQOptDone}
	        	isQOptAllDone={isQOptAllDone}
				checkWinCondition={checkWinCondition}
				hasAnsweredCallback={hasAnsweredCallback}
				answerSet={answerSet}
				userGameStatus={userGameStatus}
			/>
		</div>
	);
}